import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class IndependentReviewVideo extends Component {
  static propTypes = {
    placeholderImage: PropTypes.string,
    videoUrl: PropTypes.string,
  };

  state = {
    userRequestedVideo: false,
  };

  userRequestedVideo = () => {
    this.setState({ userRequestedVideo: true });
  };

  renderVideo = () => {
    if (this.state.userRequestedVideo) {
      return (
        <iframe
          allowFullScreen
          ref="iframe"
          src={this.props.videoUrl + '&responsive=true&autostart=true'}
          title="videoUrl"
        />
      );
    }

    return (
      <div
        className="ac-independent-review__video-placeholder"
        onClick={this.userRequestedVideo}
        onKeyPress={this.userRequestedVideo}
        ref="placeholder"
        role="button"
        style={{
          backgroundImage: `url("${this.props.placeholderImage}")`,
        }}
        tabIndex="0"
      />
    );
  };

  render() {
    return (
      <div className="ac-independent-review__video ac-product__video-wrapper js-off--hide">
        {this.renderVideo()}
      </div>
    );
  }
}
